import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Global audio mute service for the entire SPA.
 * Controls whether any audio output (voice chat, notifications, etc.) is muted.
 */
@Injectable({ providedIn: 'root' })
export class AudioMuteService {
  private readonly mutedSubject = new BehaviorSubject<boolean>(false);

  get muted$(): Observable<boolean> {
    return this.mutedSubject.asObservable();
  }

  get isMuted(): boolean {
    return this.mutedSubject.value;
  }

  setMuted(muted: boolean): void {
    this.mutedSubject.next(muted);
  }

  toggle(): void {
    this.mutedSubject.next(!this.mutedSubject.value);
  }
}
